import { Col, FormControl, FormGroup, Row } from 'react-bootstrap';
import { ICheekSwabRequestValidation } from './cheek-swab-request-validation';
import { CheckSwabRequestRenderType } from '.';

interface IProps {
    type: CheckSwabRequestRenderType,
    firstName: string,
    lastName: string,
    address1: string,
    address2: string,
    city: string,
    state: string,
    postalCode: string,
    contactPhone: string,
    email: string,
    dob: string,
    dirty: boolean,
    validation: ICheekSwabRequestValidation,
    onChange: (name: string, value: any) => void
}

const CheekSwabRequestFormContent = (props: IProps) => {
    const handleFieldChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let { name, value } = e.currentTarget;
        props.onChange(name, value);
    }

    return (
        <>
            <Row>
                <Col md={12}>
                    <FormGroup validationState={props.dirty && props.validation.firstName == false ? 'error' : null}>
                        <label>First Name <span style={{ color: 'darkred' }}>*</span></label>
                        <FormControl
                            name='firstName'
                            value={props.firstName}
                            onChange={handleFieldChange}
                        />
                    </FormGroup>
                </Col>

                <Col md={12}>
                    <FormGroup validationState={props.dirty && props.validation.lastName == false ? 'error' : null}>
                        <label>Last Name <span style={{ color: 'darkred' }}>*</span></label>
                        <FormControl
                            name='lastName'
                            value={props.lastName}
                            onChange={handleFieldChange}
                        />
                    </FormGroup>
                </Col>
            </Row>

            <FormGroup validationState={props.dirty && props.validation.address1 == false ? 'error' : null}>
                <label>Address 1 <span style={{ color: 'darkred' }}>*</span></label>
                <FormControl
                    name='address1'
                    value={props.address1}
                    onChange={handleFieldChange}
                />
            </FormGroup>

            <FormGroup>
                <label>Address 2</label>
                <FormControl
                    name='address2'
                    value={props.address2}
                    onChange={handleFieldChange}
                />
            </FormGroup>

            <Row>
                <Col md={6}>
                    <FormGroup validationState={props.dirty && props.validation.city == false ? 'error' : null}>
                        <label>City <span style={{ color: 'darkred' }}>*</span></label>
                        <FormControl
                            name='city'
                            value={props.city}
                            onChange={handleFieldChange}
                        />
                    </FormGroup>
                </Col>

                <Col md={2}>
                    <FormGroup validationState={props.dirty && props.validation.state == false ? 'error' : null}>
                        <label>State <span style={{ color: 'darkred' }}>*</span></label>
                        <FormControl
                            name='state'
                            value={props.state}
                            onChange={handleFieldChange}
                        />
                    </FormGroup>
                </Col>
                <Col md={4}>
                    <FormGroup validationState={props.dirty && props.validation.postalCode == false ? 'error' : null}>
                        <label>Postal Code <span style={{ color: 'darkred' }}>*</span></label>
                        <FormControl
                            name='postalCode'
                            value={props.postalCode}
                            onChange={handleFieldChange}
                        />
                    </FormGroup>
                </Col>
            </Row>

            {props.type != CheckSwabRequestRenderType.Center && (
                <>
                    <FormGroup validationState={props.dirty && props.validation.contactPhone == false ? 'error' : null}>
                        <label>Contact Phone <span style={{ color: 'darkred' }}>*</span></label>
                        <FormControl
                            name='contactPhone'
                            value={props.contactPhone}
                            onChange={handleFieldChange}
                        />
                    </FormGroup>

                    <FormGroup validationState={props.dirty && props.validation.email == false ? 'error' : null}>
                        <label>Email <span style={{ color: 'darkred' }}>*</span></label>
                        <FormControl
                            name='email'
                            type='email'
                            value={props.email}
                            onChange={handleFieldChange}
                        />
                    </FormGroup>

                    <FormGroup validationState={props.dirty && props.validation.dob == false ? 'error' : null}>
                        <label>DOB <span style={{ color: 'darkred' }}>*</span></label>
                        <FormControl
                            name='dob'
                            type='date'
                            value={props.dob}
                            onChange={handleFieldChange}
                        />
                    </FormGroup>
                </>
            )}
        </>
    );
}

export default CheekSwabRequestFormContent;